import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { App as DemoPage } from "./App";
import { MarketingPage } from "./pages/Marketing";
import { AuthEntryPage } from "./pages/AuthEntry";
import { AudienceRolePage } from "./pages/AudienceRole";
import { installAuthInterceptor } from "./lib/authInterceptor";
import { applyDocumentLocale } from "./lib/useDemoLocale";
import "./globals.css";

/**
 * L1 Phase 2 — full Vite app with all four production routes.
 *
 *   /                    → marketing component preview (Home)
 *   /auth/entry          → token form gate
 *   /audience/:role      → lens redirect (banker/investor/regulator/
 *                          enterprise/external → /demo[?lens=...])
 *   /demo                → main demo (HUD + SceneRouter + chrome)
 *   /rundemo (or any *)  → redirect to /demo
 *
 * The 401 interceptor catches unauthenticated /api/* calls and
 * redirects to /auth/entry?from=<current>, replacing the Next
 * middleware's server-side auth-redirect during the migration.
 */
installAuthInterceptor();
applyDocumentLocale();

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/"                element={<MarketingPage />} />
        <Route path="/auth/entry"      element={<AuthEntryPage />} />
        <Route path="/audience/:role"  element={<AudienceRolePage />} />
        <Route path="/demo"            element={<DemoPage />} />
        <Route path="*"                element={<Navigate to="/demo" replace />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
